// Form validation for Company contact form - MSP Configuration
import { plaintextValidator } from '../fields';

const config = { mandatory: true };

const customPortalChecker = {
  customDomain: {
    regexChecker: {
      //   regex: /^([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z]{2,})?$/i  // Start with any
      regex: /^[a-zA-Z]([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z]{2,})?(\.[a-zA-Z]{2,})?$/i // Dont start with number
    }
  }
};

export default (mandateDomain) =>
  mandateDomain
    ? {
        customDomain: plaintextValidator(config),
        ...customPortalChecker
      }
    : { name: plaintextValidator(config) };
